import { render, staticRenderFns } from "./MessageNotification.vue?vue&type=template&id=14958f88&scoped=true"
import script from "./MessageNotification.vue?vue&type=script&lang=js"
export * from "./MessageNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14958f88",
  null
  
)

export default component.exports